import { type CallParticipant } from '../../useCallParticipants';
import { useIntl } from '@doxyme/locale';
import { toast } from '@doxyme/ui/components/foundations';
import { Icon } from '@doxyme/icons';

export const useNotificationPatientLeft = () => {
  const { formatMessage } = useIntl();

  return (participant: CallParticipant) =>
    toast({
      title: formatMessage(
        { id: 'patientLeftCall' },
        { name: participant.username },
      ),
      icon: <Icon.Door size='medium' />,
    });
};
